module.exports = __webpack_public_path__ + "img/LazyScreenLogin.261bc6cb.png";